var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame-main",class:{minSide:_vm.stage.setting.loc.sideMode==='min'}},[_c('Head',{on:{"openNotice":_vm.openNotice}}),_vm._v(" "),_c('article',[_c('transition',{attrs:{"name":"fade","mode":"out-in","duration":{enter:500,leave:200}}},[_c('router-view')],1),_vm._v(" "),_c('Notice',{ref:"notice"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4497b8e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/frame/Bench.vue
// module id = null
// module chunks = 